"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const GenericSelectionOverlay_1 = __importDefault(require("./GenericSelectionOverlay"));
const DocumentSettingsContext_1 = require("../../context/DocumentSettingsContext");
const generateDocumentStyles_1 = require("../../utils/generateDocumentStyles");
const api_1 = require("../../api");
const RichTextEditorToolbar_1 = __importDefault(require("../RichTextEditorToolbar"));
const SessionBuilderContext_1 = require("../../context/SessionBuilderContext");
const WordCodePreview = ({ code, isDragging, isEditing }) => {
    const { settings } = (0, DocumentSettingsContext_1.useDocumentSettings)();
    const [editorHtml, setEditorHtml] = react_1.default.useState("");
    const { setGeneratedCode } = (0, SessionBuilderContext_1.useSessionBuilder)();
    const wasEditingRef = react_1.default.useRef(false);
    const wrapWordPages = (html) => {
        const pages = html.split('<div class="page-break"></div>');
        return pages
            .map((pageHtml) => `
        <div class="word-page">
          ${settings.headerFooter.showHeader
            ? `<div class="header">${settings.headerFooter.headerText || "Header"}</div>`
            : ""}
          <div class="content">${pageHtml}</div>
          ${settings.headerFooter.showFooter
            ? `<div class="footer">${settings.headerFooter.footerText || "Footer"}</div>`
            : ""}
        </div>
      `)
            .join("");
    };
    const htmlWithStyles = `
    <style>
      ${(0, generateDocumentStyles_1.generateDocumentStyles)(settings, api_1.DOC_TYPE.WORD)}
      .page-break { display: none; }
    </style>
    ${wrapWordPages(code)}
  `;
    const editorContentStyle = `
    ${(0, generateDocumentStyles_1.generateDocumentStyles)(settings, api_1.DOC_TYPE.WORD)}
    .page-break { display: none; }
  `;
    // Extract raw content from editor HTML by unwrapping .word-page/.content and rejoining with page-breaks
    const unwrapFromEditor = (html) => {
        try {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const pageNodes = Array.from(doc.querySelectorAll(".word-page"));
            if (pageNodes.length === 0)
                return html;
            const contents = pageNodes.map((page) => {
                const content = page.querySelector(".content");
                return content ? content.innerHTML : "";
            });
            return contents.join('<div class="page-break"></div>');
        }
        catch (_a) {
            return html;
        }
    };
    // Keep local editor HTML in sync when incoming code changes
    react_1.default.useEffect(() => {
        setEditorHtml(wrapWordPages(code));
    }, [code]);
    // Commit edited content back to context when exiting edit mode
    react_1.default.useEffect(() => {
        if (wasEditingRef.current && !isEditing) {
            const raw = unwrapFromEditor(editorHtml);
            setGeneratedCode(raw);
        }
        wasEditingRef.current = !!isEditing;
    }, [isEditing, editorHtml, setGeneratedCode]);
    return ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: { position: "relative", height: "100%" }, children: isEditing ? ((0, jsx_runtime_1.jsx)(RichTextEditorToolbar_1.default, { value: editorHtml, onChange: (newHtml) => setEditorHtml(newHtml), disabled: isDragging, contentStyle: editorContentStyle })) : ((0, jsx_runtime_1.jsx)(GenericSelectionOverlay_1.default, { code: htmlWithStyles, iframeStyle: { minHeight: "500px", width: "100%", border: "none" }, title: "Word Preview", isDragging: isDragging })) }));
};
exports.default = WordCodePreview;
